<div class="ap-fields-ndi-stats">
  <div class="ap-fields-ndi-stats-dropdown">
    <kendo-combobox [data]="dropdownSelectionItems"
                    [valueField]="'Id'"
                    [textField]="'Text'"
                    [allowCustom]="false"
                    [clearButton]="false"
                    [value]="selectedDropDownItem | async"
                    (valueChange)="selectedDropDownItem.next($event)"
    ></kendo-combobox>
  </div>
  <ng-container *ngIf="!(dataPresence | async)?.IsGenericBarsDataPresent && !(dataPresence | async)?.IsPlotBoxDataPresent">
    <div class="empty-message">
      <p>{{emptyMessage | translate}}</p>
    </div>
  </ng-container>
  <ng-container *ngIf="(dataPresence | async)?.IsGenericBarsDataPresent || (dataPresence | async)?.IsPlotBoxDataPresent">
    <h3>{{title | translate}}</h3>
    <ng-container *ngIf="(dataPresence | async)?.IsGenericBarsDataPresent">
      <div class="ap-fields-ndi-stats-bars">
        <ap-generic-bar-chart [data]="genericBarsData | async"
        ></ap-generic-bar-chart>
      </div>
    </ng-container>
    <ng-container *ngIf="(dataPresence | async)?.IsPlotBoxDataPresent">
      <div class="ap-fields-ndi-stats-plot-box">
        <ap-box-plot-chart [title]="plotBoxTitle"
                           [data]="plotBoxData | async"
        ></ap-box-plot-chart>
      </div>
    </ng-container>
  </ng-container>
</div>
